import { ChangeEventHandler, CSSProperties } from 'react';
import { useIntl } from 'react-intl';
import { SectionHeading, Input } from '@ets/design-system';

import { useDispatch } from '_common/hooks';
import { openAndUpdateModal } from '_common/modals/ModalsSlice';

type FieldHeadingProps = {
  field: Affiliation.Field;
  search: string;
  margin: CSSProperties['margin'];
  onFilterChange: (filterValue: string) => void;
};

const FieldHeading = ({ field, search, margin, onFilterChange }: FieldHeadingProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleFilterChange: ChangeEventHandler<HTMLInputElement> = (e) =>
    onFilterChange(e.target.value);

  const nameField = () => {
    if (field === 'address1') {
      return 'address 1st line';
    }
    if (field === 'address2') {
      return 'address 2nd line';
    }
    if (field === 'zip_code') {
      return 'zip code';
    }
    return field;
  };
  return (
    <SectionHeading
      size="l"
      sticky
      title={nameField().slice(0, 1).toUpperCase() + nameField().slice(1)}
      searchBar={
        <Input
          prefix="search"
          placeholder={intl.formatMessage({ id: 'global.search' })}
          value={search}
          onChange={handleFilterChange}
          size="m"
          testId={`affiliation-${field.toLocaleLowerCase()}-search`}
          margin="0 1rem 0 0"
        />
      }
      firstAction={{
        onClick: () =>
          dispatch(
            openAndUpdateModal({
              modal: 'AddAffiliationModal',
              data: {
                field,
              },
            }),
          ),
        children: intl.formatMessage({ id: 'NEW_OPTION' }),
      }}
      style={{ margin }}
      testId={`affiliation-${field.toLocaleLowerCase()}`}
    />
  );
};

export default FieldHeading;
